const API_BASE = '/api/posts'

const blogModule = {
  namespaced: true,
  state: {
    posts: [],
    loaded: false
  },
  getters: {
    allPosts: state => state.posts,
    publishedPosts: state => state.posts.filter(p => p.published),
    draftPosts: state => state.posts.filter(p => !p.published),
    getPostById: state => id => state.posts.find(p => p._id === id),
    getPostsByTag: state => tag => state.posts.filter(p => p.published && p.tags.includes(tag)),
    allTags: state => {
      const tags = new Set()
      state.posts.forEach(post => {
        if (post.tags) post.tags.forEach(tag => tags.add(tag))
      })
      return Array.from(tags)
    }
  },
  mutations: {
    SET_POSTS(state, posts) {
      state.posts = posts
      state.loaded = true
    },
    ADD_POST(state, post) {
      state.posts.unshift(post)
    },
    UPDATE_POST(state, updatedPost) {
      const index = state.posts.findIndex(p => p._id === updatedPost._id)
      if (index !== -1) {
        state.posts.splice(index, 1, updatedPost)
      }
    },
    DELETE_POST(state, postId) {
      state.posts = state.posts.filter(p => p._id !== postId)
    }
  },
  actions: {
    async fetchPosts({ commit, state }) {
      if (state.loaded) return
      try {
        const res = await fetch(API_BASE)
        const posts = await res.json()
        commit('SET_POSTS', posts)
      } catch (err) {
        console.error('Failed to fetch posts:', err)
      }
    },
    async addPost({ commit }, post) {
      try {
        const res = await fetch(API_BASE, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(post)
        })
        const newPost = await res.json()
        commit('ADD_POST', newPost)
      } catch (err) {
        console.error('Failed to add post:', err)
      }
    },
    async updatePost({ commit }, post) {
      try {
        const res = await fetch(`${API_BASE}/${post._id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(post)
        })
        const updated = await res.json()
        commit('UPDATE_POST', updated)
      } catch (err) {
        console.error('Failed to update post:', err)
      }
    },
    async deletePost({ commit }, postId) {
      try {
        await fetch(`${API_BASE}/${postId}`, { method: 'DELETE' })
        commit('DELETE_POST', postId)
      } catch (err) {
        console.error('Failed to delete post:', err)
      }
    },
    async togglePublish({ commit }, postId) {
      try {
        const res = await fetch(`${API_BASE}/${postId}/toggle-publish`, { method: 'PATCH' })
        const updated = await res.json()
        commit('UPDATE_POST', updated)
      } catch (err) {
        console.error('Failed to toggle publish:', err)
      }
    }
  }
}

export default blogModule
